import { FunctionComponent, useState, memo, ChangeEvent } from 'react'
import { MdPlayArrow } from 'react-icons/md'

import { emailBrRegExp } from 'shared/utils/formatters'

import InputText from 'shared/components/InputText'
import Button from 'shared/components/Button'
import Page from 'shared/components/Page'

import iconEmail from 'shared/assets/icons/icon-email.png'
import { colors } from 'shared/styles/colors'

import { steps } from '../../'

import { IEmailProps } from './EmailComponent.types'
import { Container, StyledError } from './styles'

const Email: FunctionComponent<IEmailProps> = ({
  setSelectedStep,
  validateEmail,
}) => {
  const [emailOk, setEmailOk] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpEmail')) {
      return true
    }

    return false
  })
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [currentEmail, setCurrentEmail] = useState('')

  const handleSubmit = async () => {
    setLoading(true)
    setErrorMessage('')

    try {
      await validateEmail.execute(currentEmail)

      setLoading(false)

      localStorage.setItem('@TMov:SignUpEmail', currentEmail)
      setSelectedStep(steps.EmailConfirm)
    } catch (e: unknown) {
      setLoading(false)
      setErrorMessage(
        e instanceof Error ? e.message : 'Erro na verificação do email',
      )
    }
  }

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setEmailOk(false)
    setErrorMessage('')

    if (!e.target.value) return
    try {
      setCurrentEmail(e.target.value)
      const result = emailBrRegExp.test(e.target.value)
      if (result) {
        setEmailOk(true)
      } else {
        setErrorMessage('E-mail inválido!')
      }
    } catch (e) {
      setEmailOk(false)
    }
  }

  return (
    <Page
      title="Seja bem-vindo (a) ao TMOV! <br /> Para começarmos seu cadastro, insira seu email:"
      icon={iconEmail}
      goBackTo={() => {
        setSelectedStep(steps.Terms)
      }}
    >
      <Container>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <InputText placeholder="Digite seu e-mail" onChange={handleChange} />
          {errorMessage ? <StyledError>{errorMessage}</StyledError> : <></>}
        </div>
        <Button
          color={emailOk ? colors.green : colors.grayLight}
          disabled={!emailOk || loading}
          loading={loading}
          onClick={handleSubmit}
        >
          <MdPlayArrow /> Próximo
        </Button>
      </Container>
    </Page>
  )
}

export default memo(Email)
